import "./ThePlanner.module.css";
import Navigation from "@/reusable_sections/Header";
import ToolsPreview from "./sections/ToolsPreview";
import ToolCapabilities from "./sections/ToolCapabilities";
import StoreFooter from "@/reusable_sections/Footer";
export default function ThePlannerPage() {
  return <div>
      <Navigation />
      <ToolsPreview />
      <ToolCapabilities />
      <StoreFooter />
    </div>;
}